import Button from '@/common/Button';
import { InputWithIcon } from '@/components/Input';
import QueryFilters from '@/components/QueryFilters';
import TrainingPageNavigationDropdown from '@/features/Settings/components/TrainingPageNavigationDropdown';
import { onEnter } from '@/utils';
import { useCategoriesState } from '@/features/Settings/pages/Categories';

const CategoryFilters = (): JSX.Element => {
  const [{ name, fetch, onReset }, setState] = useCategoriesState(({ state, setState }) => [
    {
      name: state.filters.name,
      fetch: state.fetch,
      onReset: state.onReset,
    },
    setState,
  ]);

  const handleChange = (value: string): void => setState((current) => ({ ...current, filters: { ...current.filters, name: value } }));

  return (
    <QueryFilters className="CategoryFilters justify-content-between">
      <div className="d-flex gap-2">
        <QueryFilters.Control>
          <InputWithIcon
            icon={<i className="sv sv-magnifier fs-4" />}
            name="name"
            value={name || ''}
            onChange={handleChange}
            onKeyDown={onEnter(fetch)}
            placeholder="Search"
          />
        </QueryFilters.Control>
        <QueryFilters.Control>
          <Button name="SUBMIT_SEARCH" variant="success" className="border-white" onClick={fetch}>
            GO
          </Button>
          <Button name="RESET_SEARCH" variant="outline-light" onClick={onReset}>
            Reset
          </Button>
        </QueryFilters.Control>
      </div>
      <div className="d-flex gap-2">
        <QueryFilters.Input>
          <TrainingPageNavigationDropdown />
        </QueryFilters.Input>
      </div>
    </QueryFilters>
  );
};

export default CategoryFilters;
